let messengerBrandTooltipTimeout;

export const showMessengerBrandCustomTooltips = (tooltipModel, thisChart, imageList, messengerBrandList: { [messenger: string]: string }) => {
  window.clearTimeout(messengerBrandTooltipTimeout);

  // Tooltip Element
  let tooltipEl = document.getElementById('messenger-chartjs-tooltip');

  // Create element on first render
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'messenger-chartjs-tooltip';
    tooltipEl.innerHTML =
      '<table style="margin-left: 10px; margin-top: 5px;"></table><div></div>';
    document.body.appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltipModel.opacity === 0) {
    window.clearTimeout(messengerBrandTooltipTimeout);
    tooltipEl.style.opacity = '0';
    return;
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform');
  if (tooltipModel.yAlign) {
    tooltipEl.classList.add(tooltipModel.yAlign);
  } else {
    tooltipEl.classList.add('no-transform');
  }

  const chartDatasets = thisChart._data.datasets;
  const chartLabels = thisChart._data.labels;
  let messengerClass;

  // Set Text
  if (tooltipModel.body) {
    const titleLines = tooltipModel.title || [];
    const bodyLines = tooltipModel.dataPoints.map(datapoint => {
      const rawValue = chartDatasets[datapoint.datasetIndex].data[datapoint.index];
      const messengerLabel = chartLabels[datapoint.index];
      messengerClass = Object.keys(messengerBrandList).find(msg => messengerBrandList[msg] === messengerLabel);
      return `${messengerLabel}: ${rawValue >= 0 ? rawValue.toLocaleString() : 'N/A'}`;
    });

    let innerHtml = '<thead>';

    /*titleLines.forEach((title) => {
      innerHtml += '<tr><th style="text-align: center">' + title + '</th></tr>';
    });*/
    innerHtml += '</thead><tbody>';

    bodyLines.forEach((body, i) => {
      const colors = tooltipModel.labelColors[i];
      let style = 'background:' + colors.backgroundColor;
      style += '; border-color:' + colors.borderColor;
      style += '; border-width: 2px';
      style += '; display: inline-block';
      style += '; width: 15px';
      style += '; height: 15px';
      style += '; margin-right: 5px';
      style += '; vertical-align: middle';
      const span = '<span style="' + style + '"></span>';
      innerHtml += '<tr><td style="vertical-align: middle;">' + span + body + '</td></tr>';
    });
    innerHtml += '</tbody>';

    const tableRoot = tooltipEl.querySelector('table');
    tableRoot.innerHTML = innerHtml;
  }

  const imageRoot = tooltipEl.querySelector('div');
  const imageSrc1 = imageList?.[messengerClass]?.[0] || '../assets/image/placeholder.png';
  const imageSrc2 = imageList?.[messengerClass]?.[1] || '../assets/image/placeholder.png';

  imageRoot.innerHTML =
    `<img style="width: 60px; height: 135px; margin: 5px 5px;" src="${imageSrc1}"></img>` +
    `<img style="width: 60px; height: 135px; margin: 5px 5px;" src="${imageSrc2}"></img>`;

  // `this` will be the overall tooltip
  const position = thisChart._chart.canvas.getBoundingClientRect();

  // Display, position, and set styles for font
  tooltipEl.style.opacity = '3';
  tooltipEl.style.position = 'absolute';
  // tooltipEl.style.left = (position.left + window.pageXOffset + tooltipModel.caretX ) + 'px';
  // tooltipEl.style.top = (position.top + window.pageYOffset + tooltipModel.caretY - 100) + 'px';
    // relative to the ting
  const showingReact = tooltipEl.getBoundingClientRect();
  const calLeftPx = (position.left + window.pageXOffset + tooltipModel.caretX - (showingReact.width));
  tooltipEl.style.left = (calLeftPx < 0 ? 0 : calLeftPx) + 'px';
  tooltipEl.style.top = (position.top + window.pageYOffset + tooltipModel.caretY - (showingReact.height)) + 'px';
  tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
  tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
  tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
  tooltipEl.style.padding =
    tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
  tooltipEl.style.pointerEvents = 'none';
  tooltipEl.style.backgroundColor = 'rgba(0,0,0, 0.8)';
  tooltipEl.style.color = 'white';
  tooltipEl.style.borderRadius = '5px';

  messengerBrandTooltipTimeout = setTimeout(() => {
    tooltipEl.style.opacity = '0';
  }, 2500);
};
